export enum ServiceContractJobType {
	Regular = 1,
	Support = 2,
	DigitalLogbook = 3,
	SmartDocs = 4
}
